const nonShipmentSurchargeResponseToNonShipmentSurchargeObject = (response) => ({
    id: response.id,
    integrationId: response.integration_id,
    lineNumber: response.line_number,
    externalOrderId: response.external_id,
    invoiceDate: response.invoice_date,
    transactionDate: response.transaction_date,
    invoiceNumber: response.invoice_number,
    surchargeValue: response.surcharge_value,
    surchargeType: response.non_shipment_surcharge_type,
    errorMessage: response.error_message,
});

export { nonShipmentSurchargeResponseToNonShipmentSurchargeObject };
